/**
 * Navigation glyph registry.
 * ---------------------------------------------------------------
 * Route → mark, so the sidebar, the mobile bar/sheet and the command palette
 * all show the same drawing for the same destination.
 */
export * from './glyphs';

import type { SkillGlyph } from '@/components/skilltree/svg/glyph';
import {
  HomeGlyph,
  PersonalityGlyph,
  DomainsGlyph,
  CardsGlyph,
  ReportsGlyph,
  HistoryGlyph,
  AccountGlyph,
  AssessGlyph,
  IntegralGlyph,
  QuizzesGlyph,
  IQGlyph,
  ReflectGlyph,
  RelationshipsGlyph,
  BookmarksGlyph,
  LikerGlyph,
  MentorGlyph,
  CareerGlyph,
  AstrologyGlyph,
  CommunityGlyph,
  WalletGlyph,
  ShopGlyph,
  ScienceGlyph,
  AdminGlyph,
  CrownGlyph,
  LeaderboardGlyph,
  PeopleGlyph,
  ExploreGlyph,
} from './glyphs';

export const NAV_GLYPHS: Record<string, SkillGlyph> = {
  '/': HomeGlyph,
  '/personality': PersonalityGlyph,
  '/tps-profile': DomainsGlyph,
  '/cards': CardsGlyph,
  '/reports': ReportsGlyph,
  '/history': HistoryGlyph,
  '/profile': AccountGlyph,
  '/tps-assessment-hub': AssessGlyph,
  '/integral': IntegralGlyph,
  '/skill-tree': IntegralGlyph,
  '/quizzes': QuizzesGlyph,
  '/iq-test': IQGlyph,
  '/reflect': ReflectGlyph,
  '/relationships': RelationshipsGlyph,
  '/bookmarks': BookmarksGlyph,
  '/liker': LikerGlyph,
  '/mentor': MentorGlyph,
  '/career': CareerGlyph,
  '/astrology': AstrologyGlyph,
  '/earn': WalletGlyph,
  '/shop': ShopGlyph,
  '/science': ScienceGlyph,
  '/admin': AdminGlyph,
  '/subscription': CrownGlyph,
  '/leaderboard': LeaderboardGlyph,
  '/commons': PeopleGlyph,
  '/social/boards': PeopleGlyph,
  '/social/mail': PeopleGlyph,
  '/social/members': PeopleGlyph,
  '/explore': ExploreGlyph,
};

export function navGlyph(path: string): SkillGlyph {
  return NAV_GLYPHS[path] ?? CommunityGlyph;
}
